import { Component } from '@angular/core';
@Component({
  template: '',
})
export class LowerBound {
  startingPoint: any;
  reduce: number = 0;
  max: number = 0;
  min: number = 0;
  start: any = [];
  ngOnInit(): void {}
  calcLowerBound(qParam) {
    this.start = [];
    for (let i = 0, sum = 0; i < qParam.length; ++i) {
      if (i === 0) {
        //
      } else {
        sum += qParam[i - 1];
        if (qParam[i] < 0) {
          this.start.push(sum + qParam[i]);
        } else {
          this.start.push(sum);
        }
      }
    }
    this.min = Math.min(...this.start);
    this.max = Math.max(...this.start);
    this.reduce = (this.max - this.min) * (0 / 100);
    let startPoint;
    if (this.min > 0) {
      startPoint = this.min - this.reduce;
    } else {
      startPoint = this.min;
    }
    if (startPoint >= this.min) {
      if (startPoint > 0) {
        this.startingPoint = (this.min * 0) / 100;
      } else {
        this.startingPoint = this.min + (this.min * 0) / 100;
      }
    } else {
      this.startingPoint = startPoint;
    }

    return this.startingPoint;
  }

// Adjust the waterfall baseline for totals while preserving original values and impact bars..
  /**
   * Raises the waterfall axis to just below the lowest plotted point and
   * starts Sales / Demand Sales totals on that floor. Bar labels still read
   * the original end values; only the visual baseline changes.
   * Total bars are reference rows (column 3 is 1 or 2). Impact rows keep
   * their real start and end.
   */
  prepareSalesWaterfall(
    waterfallData: any[][],
    scaleBreak: boolean
  ): { data: any[][]; startingPoint: number } {
    const data = Array.isArray(waterfallData)
      ? waterfallData.map((row) => (Array.isArray(row) ? [...row] : row))
      : [];
    if (!scaleBreak) {
      return { data, startingPoint: 0 };
    }
    return { data, startingPoint: this.applySalesScaleBreak(data) };
  }

  applySalesScaleBreak(waterfallData: any[][]): number {
    if (!Array.isArray(waterfallData)) {
      return 0;
    }

    const points: number[] = [];
    for (let i = 1; i < waterfallData.length; i++) {
      const row = waterfallData[i];
      if (!Array.isArray(row)) {
        continue;
      }
      if (this.isTotalBar(row)) {
        this.pushFinite(points, row[2]);
      } else {
        this.pushFinite(points, row[1]);
        this.pushFinite(points, row[2]);
      }
    }

    const floor = this.salesScaleFloor(points);
    for (let i = 1; i < waterfallData.length; i++) {
      const row = waterfallData[i];
      if (Array.isArray(row) && this.isTotalBar(row)) {
        row[1] = floor;
      }
    }
    return floor;
  }

  private isTotalBar(row: any[]): boolean {
    return row[3] === 1 || row[3] === 2;
  }

  private pushFinite(points: number[], value: any): void {
    if (value === null || value === undefined || value === '') {
      return;
    }
    const numeric = typeof value === 'number' ? value : Number(value);
    if (Number.isFinite(numeric)) {
      points.push(numeric);
    }
  }

  private salesScaleFloor(points: number[]): number {
    if (!points.length) {
      return 0;
    }
    const min = Math.min(...points);
    const max = Math.max(...points);
    const span = max - min;
    const paddingRatio = 0.3;
    let floor: number;
    if (span === 0) {
      floor = min - Math.abs(min) * paddingRatio;
    } else {
      floor = min - span * paddingRatio;
    }
    if (min >= 0 && floor < 0) {
      return 0;
    }
    return floor;
  }
}
